import React, { Component } from 'react';
import './css/main.css';
import { Helmet } from "react-helmet";

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import ProjectInfo from './layout/portfolio/ProjectInfo';
import ImageGridFront from './layout/portfolio/ImageGridFront';
import BriefIcon from './layout/hero/BriefIcon';
import GalleryGridx2 from './layout/portfolio/GalleryGridx2';
import DeviceGridx2 from './layout/portfolio/DeviceGridx2';
import DeviceGridx1 from './layout/portfolio/DeviceGridx1';
import ImageGridx1 from './layout/portfolio/ImageGridx1';
import ImageGridx2 from './layout/portfolio/ImageGridx2';

import WarpLarge from './layout/warp/WarpLarge';
import NextUp from './layout/warp/NextUp';

// images
import gridFirst from './img/monoshift/MercBClass2@2x.jpg';
import gridSecond from './img/monoshift/MercBClass1@2x.jpg';
import PenIcon from './asset/PenIcon';

const workContent =
  {
    client: "Intern Designer",
    type: "Visual Design, Pitch, Marketing",
    description: "Monoshift is creative agency in South Korea. The company's main goal was delivering an unique design experience with the latest technology. I was a university student who were a big fan of their projects, I emailed the director that I wanted to work as an intern and luckickly got a chance to work with them for 4 months!"
  };

const projectBrief = {
  summary: "Pweng",
  titleIcon: PenIcon,
  title: "Nyangu!",
  paragraph: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore eos iusto, vitae laborum nulla sunt ipsum sint saepe ullam fuga magni quidem, et harum, adipisci atque sapiente ducimus rerum, praesentium.",
  themeColor: '#ff5151',
}

class PortfolioUI extends Component {
  render() {
    return (
      <div>
        <Navigation />
        <ImageGridFront first={gridFirst} title={"Nyang"} themeColor={'#515151'} />
        <ProjectInfo client={workContent.client} type={workContent.type} description={workContent.description}/>
        <ImageGridx1 first={gridFirst} innerDescription={<BriefIcon summary={projectBrief.summary} titleIcon={<PenIcon color={projectBrief.themeColor}/>} title={projectBrief.title} paragraph={projectBrief.paragraph} textColor={projectBrief.themeColor}/>}themeColor={'#515151'} true/>

        <BriefIcon summary={projectBrief.summary} titleIcon={<PenIcon color={projectBrief.themeColor}/>} title={projectBrief.title} paragraph={projectBrief.paragraph} textColor={projectBrief.themeColor}/>

        <ImageGridx2 first={gridFirst} second={gridSecond}/>
        <GalleryGridx2 first={gridFirst} second={gridSecond}/>
        <DeviceGridx2 first={gridFirst} second={gridSecond}/>
        <DeviceGridx1/>
        <NextUp/>

        <WarpLarge/>
        <Footer/>
      </div>
    );
  }
}

export default PortfolioUI;



// WEBPACK FOOTER //
// ./src/PortfolioUI.js